import React, { useState } from 'react';
import { Music4, Eye, EyeOff, Mail, Lock, Github } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/Button';

export const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      await new Promise((resolve) => setTimeout(resolve, 2000));
      console.log('Login realizado com:', { email, password });
      // Aqui você usaria o hook useNavigate() para redirecionar o usuário
    } catch (error) {
      console.error('Erro ao entrar');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 antialiased hero-pattern flex flex-col">
      <header className="p-8">
        <Link to="/" className="flex items-center gap-2 w-fit group">
          <div className="w-10 h-10 gold-gradient rounded-full flex items-center justify-center text-white shadow-lg group-hover:scale-110 transition-transform">
            <Music4 size={24} />
          </div>
          <span className="text-xl font-bold tracking-tight text-slate-800">
            Encant<span className="text-[#D4AF37]">.Me</span>
          </span>
        </Link>
      </header>

      <main className="flex-grow flex items-center justify-center px-6 pb-12">
        <div className="w-full max-w-md bg-white rounded-[2.5rem] shadow-2xl border border-slate-100 p-10">
          <div className="text-center mb-10">
            <h1 className="text-3xl font-black text-slate-800 mb-2">Bem-vindo de volta</h1>
            <p className="text-slate-500">Acesse sua conta para gerenciar suas músicas</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="space-y-2">
              <label className="text-sm font-bold text-slate-700 ml-1">E-mail</label>
              <div className="relative">
                <Mail className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" size={20} />
                <input 
                  type="email" 
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full pl-12 pr-5 py-4 rounded-2xl border border-slate-200 focus:border-gold-primary focus:ring-4 focus:ring-gold-primary/10 outline-none transition-all bg-slate-50/50"
                  placeholder="seu@email.com"
                />
              </div>
            </div>

            <div className="space-y-2">
              <div className="flex justify-between items-center px-1">
                <label className="text-sm font-bold text-slate-700">Senha</label>
                <a href="#" className="text-xs font-semibold text-gold-secondary hover:underline">Esqueceu a senha?</a>
              </div>
              <div className="relative">
                <Lock className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" size={20} />
                <input 
                  type={showPassword ? "text" : "password"}
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full pl-12 pr-14 py-4 rounded-2xl border border-slate-200 focus:border-gold-primary focus:ring-4 focus:ring-gold-primary/10 outline-none transition-all bg-slate-50/50"
                  placeholder="••••••••"
                />
                <button 
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-4 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600 transition-colors"
                >
                  {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                </button>
              </div>
            </div>

            <Button 
              type="submit" 
              className="w-full py-4 text-lg" 
              isLoading={isLoading}
            >
              Entrar na Plataforma
            </Button>

            <div className="relative py-4">
              <div className="absolute inset-0 flex items-center"><div className="w-full border-t border-slate-100"></div></div>
              <div className="relative flex justify-center text-xs uppercase"><span className="bg-white px-2 text-slate-400">Ou continue com</span></div>
            </div>

            <div className="flex flex-col gap-3">
              <Button variant="outline" type="button" className="w-full flex gap-3 py-3 font-semibold">
                {/* Google logo SVG */}
                <svg width="20" height="20" viewBox="0 0 48 48" className="inline-block" xmlns="http://www.w3.org/2000/svg"><g><path fill="#4285F4" d="M44.5 20H24v8.5h11.7C34.7 33.1 30.1 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c2.7 0 5.2.9 7.2 2.4l6.4-6.4C33.5 5.1 28.9 3 24 3 12.4 3 3 12.4 3 24s9.4 21 21 21c10.5 0 20-7.5 20-21 0-1.3-.1-2.7-.3-4z"/><path fill="#34A853" d="M6.3 14.7l7 5.1C15.5 16.1 19.4 13 24 13c2.7 0 5.2.9 7.2 2.4l6.4-6.4C33.5 5.1 28.9 3 24 3c-7.2 0-13.4 4.1-16.7 10.1z"/><path fill="#FBBC05" d="M24 45c6.1 0 11.2-2 14.9-5.4l-6.9-5.7C29.7 35.9 27 37 24 37c-6.1 0-11.3-4.1-13.2-9.7l-7 5.4C6.6 41.1 14.7 45 24 45z"/><path fill="#EA4335" d="M44.5 20H24v8.5h11.7c-1.2 3.2-4.2 5.5-7.7 5.5-2.2 0-4.2-.7-5.7-2.1l-7 5.4C18.7 41.1 21.2 42 24 42c6.1 0 11.2-2 14.9-5.4l-6.9-5.7C29.7 35.9 27 37 24 37c-6.1 0-11.3-4.1-13.2-9.7l-7 5.4C6.6 41.1 14.7 45 24 45z"/></g></svg>
                Google
              </Button>
              <Button variant="outline" type="button" className="w-full flex gap-3 py-3 font-semibold">
                {/* Facebook logo SVG */}
                <svg width="20" height="20" viewBox="0 0 32 32" className="inline-block" xmlns="http://www.w3.org/2000/svg"><path fill="#1877F3" d="M16 3C8.268 3 2 9.268 2 17c0 6.627 5.373 12 12 12s12-5.373 12-12c0-7.732-6.268-14-12-14zm2.5 14h-2v7h-3v-7h-1.5v-3h1.5v-1.5c0-1.379.621-3 3-3h2v3h-2c-.276 0-.5.224-.5.5V14h2.5l-.5 3z"/></svg>
                Facebook
              </Button>
            </div>
          </form>

          <p className="text-center mt-8 text-sm text-slate-500">
            Não tem uma conta?{' '}
            <Link to="/" className="text-gold-secondary font-bold hover:underline">Criar agora</Link>
          </p>
        </div>
      </main>

      <footer className="py-8 text-center text-xs text-slate-400 space-x-4">
        <span>© 2026 Encant-Me</span>
        <a href="#" className="hover:text-slate-600">Termos</a>
        <a href="#" className="hover:text-slate-600">Privacidade</a>
      </footer>
    </div>
  );
};